import { Divider, Typography } from "antd";
import React from "react";

const { Title } = Typography;

export default function PageHeader({ text, icon }) {
   return (
      <>
         <Title level={3}>
            {icon}
            <Divider type="vertical" />
            {text}
         </Title>
      </>
   );
}
